import axios from "axios";
import * as _ from "lodash";

const CHECKOUT_BASE_URL = "https://aegis.movemais.com/finalizar-pedido";
// const CHECKOUT_BASE_URL = "http://aegis-a2-iron.movemais.com/finalizar-pedido";
// A1 const CHECKOUT_BASE_URL = 'https://aegis-a1-iron.movemais.com/finalizar-pedido';
// const CHECKOUT_BASE_URL = 'http://localhost:5173/finalizar-pedido';

const PAYMENT_METHODS_BASE_URL = "https://aegis.movemais.com/formas-pagamento";
//const PAYMENT_METHODS_BASE_URL = 'http://aegis-a2-iron.movemais.com/formas-pagamento';
// A1 const PAYMENT_METHODS_BASE_URL = 'https://aegis-a1-iron.movemais.com/formas-pagamento';
// const PAYMENT_METHODS_BASE_URL = "http://localhost:5173/formas-pagamento";

function redirectToCheckout(salesToken) {
  if (!salesToken) {
    return false;
  }
  try {
    const isLogged = !!localStorage.getItem("currentUser");
    const backUrl = isLogged ? "/conta/meus-planos" : "/adesao";
    window.history.replaceState(null, "", backUrl);
  } catch (e) {
    // noop
  }
  window.location.href = `${CHECKOUT_BASE_URL}/${encodeURIComponent(salesToken)}`;
  return true;
}

function processOrderCreated(data, options = {}) {
  const payload = data && data.order ? data.order : data;
  if (options.skipCheckout && payload && payload.status === 0) {
    return Promise.resolve(payload);
  }
  if (payload && payload.status === 0 && payload.salesToken) {
    redirectToCheckout(payload.salesToken);
    return new Promise(() => {});
  }
  const code =
    payload && typeof payload.status === "number" ? payload.status : -1;
  const message =
    (payload && payload.message) || "Não foi possível concluir o pedido";
  return Promise.reject({ data: { status: { code, message }, message } });
}

function processOrderError(err) {
  if (
    err &&
    err.data &&
    err.data.status &&
    typeof err.data.status === "object"
  ) {
    return Promise.reject(err);
  }
  const response = (err && err.response) || err || {};
  const raw = (response && response.data) || {};
  if (typeof raw.status === "number") {
    return Promise.reject({
      data: {
        status: {
          code: raw.status,
          message: raw.message || "Erro ao criar pedido",
        },
        message: raw.message || "Erro ao criar pedido",
      },
    });
  }
  if (raw && raw.status && typeof raw.status === "object") {
    return Promise.reject({ data: raw });
  }
  return Promise.reject(err);
}

class SalesService {
  /**
   * Calcula a taxa de recarga
   * @param quantity quantidade de recarga
   * @returns Promise<Object> RechargeRate
   */
  calculateRechargeRate(request) {
    return axios.post(`/v2/calculateRechargeRate`, request).then((resp) => {
      // .post(`/v1/calculateRechargeRate`, request).then(resp => {
      //.rechargeRates.rechargeRate[0]
      return resp.data.response;
    });
  }

  getBannersParceiro() {
    return axios.get("/v2/banners/ativo").then((resp) => {
      return resp.data;
    });
  }

  getBannerAccess(data) {
    return axios.post("/v2/parceiros/acesso", data).then((resp) => {
      return resp.data;
    });
  }

  getBannersSite(isMobile) {
    return axios.get(`/v2/getBannersSite/${isMobile}`).then((resp) => {
      return resp.data;
    });
  }

  getBannersSiteMob(isMobile) {
    return axios.get(`/v2/getBannersSiteMob/${isMobile}`).then((resp) => {
      return resp.data;
    });
  }

  /**
   * Retorna todos os contratos ativos.
   *
   * @returns {Promise} lista com os pedidos pendentes do contrato.
   */
  // listSalesOrders(f={}) {
  //   let url = `/v1/listSalesOrders?void=void`;
  //   if(f.page)
  //     url += `&pageSize=${f.page.size()}&pageNumber=${f.page.page()}`
  //   if(f.type)
  //     url += `&type=${f.type}`;
  //
  //   if(f.statusId)
  //     url += `&statusId=${f.statusId}`;
  //
  //   return axios.get(url).then(res => {
  //
  //
  //     if (res.data.status.code == 0) {
  //       return res.data;
  //     } else {
  //       return res.data.status;
  //     }
  //   });
  //
  // }
  listSalesOrders(filter) {
    return axios.post(`/v2/listSalesOrders`, filter).then((res) => {
      if (res.data.status.code == 0) {
        res.data.itens.forEach(function (o) {
          if (o.salesType == "REPLACETAG") {
            o.salesDescription = "SUBSTITUIÇÃO DE TAG";
          } else if (o.salesType == "ADHESION") {
            o.salesDescription = "ADESÃO";
          } else if (o.salesType == "RECHARGE") {
            o.salesDescription = "RECARGA";
          } else if (o.salesType == "TRANSFER") {
            o.salesDescription = "TRANSFERÊNCIA";
          } else if (o.salesType == "TAGPURCHASEREQUEST") {
            o.salesDescription = "SOLICITAÇÃO DE TAG";
          } else if (o.salesType == "ADHESIONVEHICLEADDITIONAL") {
            o.salesDescription = "ADESÃO VEÍCULO ADICIONAL";
          } else if (o.salesType == "ADHESIOACONTRACTADDITIONAL") {
            o.salesDescription = "ADESÃO DE NOVO CONTRATO";
          } else if (o.salesType == "PAYMENTPERUSE") {
            o.salesDescription = "PASSAGEM";
          } else if (o.salesType == "CANCELAMENTO_CONTRATO") {
            o.salesDescription = "CANCELAMENTO DE CONTRATO";
          } else if (o.salesType == "TAXA_CANCELAMENTO") {
            o.salesDescription = "TAXA DE CANCELAMENTO";
          } else if (o.salesType == "MIGRATIONPLAN") {
            o.salesDescription = "MIGRAÇÃO DE PLANO";
          }
        });
        return res.data;
      } else {
        return res.data.status;
      }
    });
  }

  /**
   * Salva as informacoes de proposta
   * @param lead dados da proposta
   * @returns Promise<Object> RechargeRate
   */
  getSalesOrderId(orderId) {
    // return axios.get(`/v1/getSalesOrder/${orderId}`).then(res => {
    return axios.get(`/v2/getSalesOrder/${orderId}`).then((res) => {
      if (res.data.status.code == 0 && res.data.order) {
        res.data.order.products.forEach(function (o) {
          if (o.product) {
            o.productName = o.product.description;
            o.productId = o.product.productId;
          }
        });
        return res.data;
      } else {
        return res.data.status;
      }
    });
  }
  updateSenffOrder(orderId) {
    return axios.get(`/v2/updateSenffOrder/${orderId}`).then((res) => {
      return res.data;
    });
  }

  getDateTimeTransaction() {
    return axios.get("/v2/getDateTimeTransaction").then((res) => {
      return res.data.now;
    });
  }

  gravaLogRedirecionamentoBanner(moveMaisId, idBanner, idParceiro) {
    return axios
      .get(
        `/v2/gravaLogRedirecionamentoBanner/${moveMaisId}/${idBanner}/${idParceiro}`,
      )
      .then((res) => {
        return res.data;
      });
  }

  /**
   * Salva as informacoes de proposta
   * @param lead dados da proposta
   * @returns Promise<Object> RechargeRate
   */
  createLead(lead) {
    return axios.post("/v2/createLead", lead);
  }

  /**
   * Atualiza as informações do Lead
   * @param LEAD dados do lead
   * @returns Promise<Object> Lead
   */
  updateLead(lead) {
    return axios.post("/v2/updateLead", lead).then((response) => {
      return response.data;
    });
  }

  createANewProposal(lead) {
    return axios.post("/v1/createANewProposal", lead).then((response) => {
      return response.data;
    });
  }

  /**
   * Salva as informacoes de proposta
   * @param lead dados da proposta
   * @returns Promise<Object> RechargeRate
   */
  recharge(request) {
    return axios
      .post("/v2/recharge", request)
      .then((res) => processOrderCreated(res.data))
      .catch((err) => processOrderError(err));
  }

  redirectToCheckout(salesToken) {
    return redirectToCheckout(salesToken);
  }

  redirectToContractPayment(contractId) {
    return axios.post(`/v2/contract-token/${contractId}`).then((res) => {
      const token =
        res.data && (typeof res.data === "string" ? res.data : res.data.token);
      console.log(token, "token");
      if (!token) return Promise.reject(new Error("Token não recebido"));
      window.open(
        `${PAYMENT_METHODS_BASE_URL}/${encodeURIComponent(token)}`,
        "_blank",
      );
    });
  }

  handleOrderCreated(data) {
    return processOrderCreated(data);
  }

  /**
   * Informacoes de plano
   * @returns Promise<Object> Planos
   */
  getPlan() {
    return axios.get("/v2/getPlan").then((res) => {
      const plans = res.data.plans.plan;
      return {
        plans,
        confirmCellphone: res.data.confirmCellphone,
        confirmEmail: res.data.confirmEmail,
      }; //formato da devires
    });
  }

  /**
   * Informacoes de plano
   * @returns Promise<Object> Planos
   */
  getPlanPj() {
    return axios.get("/v2/getPlanPj").then((res) => {
      const plans = res.data.plans.plan;
      return {
        ...plans,
        confirmCellphone: res.data.confirmCellphone,
        confirmEmail: res.data.confirmEmail,
      };
    });
  }

  getPlanById(planId) {
    return this.getPlan().then((r) => {
      console.log(r, "r filter");

      return _.filter(r.plans, (o) => o.planId == planId)[0];
    });
  }

  /**
   * Adesao
   * @returns Promise<Object> Adesao
   */
  adhesion(request) {
    return axios
      .post("/v2/adhesion", request)
      .then((res) => processOrderCreated(res.data))
      .catch((err) => processOrderError(err));
  }

  /**
   * Adesao Agregado
   * @returns Promise<Object> Adesao Agregado
   */
  adhesionAggregate(request) {
    return axios
      .post("/v2/adhesionAggregate", request)
      .then((res) => processOrderCreated(res.data))
      .catch((err) => processOrderError(err));
  }

  /**
   * Adesao de veiculo adicional
   * @returns Promise<Object> Adesao
   */
  adhesionVehicleAddition(request) {
    return axios
      .post("/v2/adhesionVehicleAddition", request)
      .then((res) => processOrderCreated(res.data))
      .catch((err) => processOrderError(err));
  }

  /**
   * Pedido de substituição de tag
   * @returns Promise<Object> Pedido
   */
  requestTagReplacement(request, options = {}) {
    return axios
      .post("/v2/requestTagReplacement", request)
      .then((res) => processOrderCreated(res.data, options))
      .catch((err) => processOrderError(err));
  }

  /**
   * Busca informações do cliente referente a Caminhos do Parana
   * @returns Promise<Object> Lead
   */
  getLead(request) {
    return axios.post("/v2/getLead", request).then((res) => {
      return res.data;
    });
  }

  calculateDiscount(request) {
    return axios.post("/v2/calculateDiscount", request).then((res) => res.data);
  }

  adhesionContractAdditional(request) {
    return axios
      .post("/v2/adhesionContractAdditional", request)
      .then((res) => processOrderCreated(res.data))
      .catch((err) => processOrderError(err));
  }

  migrationPlan(request) {
    return axios
      .post("/v2/migrationPlan", request)
      .then((res) => processOrderCreated(res.data))
      .catch((err) => processOrderError(err));
  }

  hasPromotion(filter) {
    return axios
      .get(
        `/v1/hasPromotion${filter.promotionCode ? `?promotionCode=${filter.promotionCode}` : ""}`,
      )
      .then((res) => res.data);
  }

  findPlate(plate) {
    return axios
      .get(`/v1/getVehicleData/${plate}`)
      .then((res) => res.data.vehicle);
  }

  findPlateV2(plate) {
    // CASO NÃO INFORMADO A PLACA, ENVIA 'NOTPLATE' PARA NÃO QUEBRAR O SERVIÇO
    return axios
      .get(`/v2/getVehicleDataSiteVP/${plate || "NOTPLATE"}`)
      .then((res) => res.data.vehicle);
  }

  getProcessingOrders(contract, type) {
    return axios
      .get(`/v1/getProcessingOrders/${contract}/${type}`)
      .then((res) => res.data.orders);
  }

  getProcessingOrders(contract, type) {
    return axios
      .get(`/v2/getProcessingOrders/${contract}/${type}`)
      .then((res) => res.data.orders);
  }

  transferCredit(request) {
    return axios.post("/v2/transferCredit", request).then((res) => res.data);
  }

  transferCreditAggregate(request) {
    return axios
      .post("/v2/transferCreditAggregate", request)
      .then((res) => res.data);
  }

  getTransferData(transferId) {
    return axios
      .get(`/v2/getTransferData/${transferId}`)
      .then((res) => res.data);
  }
  captchaAdhesion(request) {
    return axios.get("/zeus/captcha", request).then((res) => res.data);
  }
  captchaAdhesionPost(request) {
    return axios
      .post("/zeus/captcha", request)
      .then((res) => res)
      .catch((err) => false);
  }
  findByUf(uf) {
    return axios.post(`/v2/findByUf`, uf).then((res) => res.data);
  }

  checkChargeValue(req) {
    return axios
      .post(`/v2/checkChargeValue`, req)
      .then((res) => res.data.status);
  }

  firstValueRecharge(req) {
    return axios.post(`/v2/firstValueRecharge`, req).then((res) => res.data);
  }
  validarFraudeContrato(contractId, salesOrderId, contractPaymentMethodId) {
    return axios
      .post(
        `/v2/validarFraudeContrato/${contractId}/${salesOrderId}/${contractPaymentMethodId}`,
      )
      .then((res) => res.data);
  }

  validateCoupon(coupon) {
    return axios.get(`/v2/validateCoupon/${coupon}`).then((res) => res.data);
  }

  /**
   * Consulta RNTRC do transportador na ANTT.
   * @param {string} transportador CPF/CNPJ do transportador (apenas dígitos)
   * @param {string[]} placas Lista de placas a validar
   * @returns Promise<Object> resposta da ANTT (rntrcAtivo, frota, etc.)
   */
  consultarRNTRC(transportador, placas) {
    return axios
      .post(`/v2/rntrc/consultar`, { transportador, placas })
      .then((res) => res.data);
  }
}
// Singleton
const instance = new SalesService();

export default instance;



// WEBPACK FOOTER //
// ./src/services/sales.js